module.exports = __webpack_public_path__ + "img/cu_we_door.7ceaa675.png";